import { getAppInstance } from '@/utils/api/app';
import { Channels } from '@/components/Calculator/types';

export type RepresentativeAprResponse = {
  repPrice: {
    monthlyPayment: number;
    totalInterest: number;
    interestRate: number;
    totalCredit: number;
    totalCost: number;
    years: number;
    loan: number;
    apr: number;
    fee: number;
  };
};

export const getRepresentativeApr = ({ channel = 'upl' }: Record<'channel', Channels>) =>
  getAppInstance().get<RepresentativeAprResponse>(`/represenative-apr?channel=${channel}`);
